import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-logo">
          <div className="logo-wrapper">
            <img 
              src="/images/pitac-logo1.png" 
              alt="PITAC Logo" 
              className="logo-image"
            />
            <div className="logo-text">
              <div className="logo-main">PITAC</div>
              <div className="logo-through">PAKISTAN INDUSTRIAL TECHNICAL ASSISTANCE CENTRE</div>
                          </div>
          </div>
        </Link>

        <div className={`nav-menu ${isOpen ? 'active' : ''}`}>
          <Link to="/" className="nav-link">Home</Link>
          <Link to="/about" className="nav-link">About</Link>
          <Link to="/courses" className="nav-link">Courses</Link>
          <Link to="/press-releases" className="nav-link">Press</Link>
          <Link to="/contact" className="nav-link">Contact</Link>
          <button className="nav-apply-btn">Apply Now</button>
        </div>

        <div className={`nav-toggle ${isOpen ? 'active' : ''}`} onClick={() => setIsOpen(!isOpen)}>
          <span className="bar"></span>
          <span className="bar"></span>
          <span className="bar"></span>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;